import type { ResolverTag } from '@ps/web-core-enums';
import { FeatureFlag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';

import useFeature from '@swf/core/hooks/useFeature';

import useResolverV1 from './useResolverV1';

const useResolverTagService = (tag: ResolverTag) => {
  const v1Enabled = useFeature(FeatureFlag.PKRMultiTableTournamentsResolverServiceV1);
  const resolvedTag = useResolver(tag);
  const resolvedTagV1 = useResolverV1(tag);

  return v1Enabled ? resolvedTagV1 : resolvedTag;
};

export default useResolverTagService;
